import axios from 'axios'
import { useParams } from 'react-router-dom'
import { useContext } from 'react'
import { SessionContext } from 'contexts/session'
import { useQuery } from '@tanstack/react-query'

/**
 * Collection Segments
 * @param {string} stationCode
 * @param {number} blockIndex
 * @returns UseQueryResult
 */
const useCentipedeLineupDetailsQuery = () => {
  const { stationCode, blockIndex, centipedeId } = useParams()
  const { session } = useContext(SessionContext)

  return useQuery(
    ['centipedeLineupDetails', stationCode, blockIndex, centipedeId],
    async () => {
      const apiUrl = session.server
      const axiosOptions = {
        headers: {
          Accept: 'application/json',
          papitoken: session.token,
        },
      }

      const response = await axios.get(
        `${apiUrl}station/${stationCode}/block/${blockIndex}/centipedelineups/${centipedeId}/status`,
        axiosOptions,
      )
      return response.data
    },
    { refetchInterval: 5000 },
  )
}

export default useCentipedeLineupDetailsQuery
